import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VerificationStatusComponent } from './verification-status.component';


@NgModule({
  declarations: [VerificationStatusComponent],
  imports: [
    CommonModule
  ],
  exports: [
    VerificationStatusComponent
  ]
})
export class VerificationStatusModule { }
